import { alpha } from '@mui/material/styles';
export default function ToggleButton(theme) {
    const style = (color)=>({
            props: {
                color
            },
            style: {
                '&:hover': {
                    borderColor: alpha(theme.palette[color].main, 0.48),
                    backgroundColor: alpha(theme.palette[color].main, theme.palette.action.hoverOpacity)
                },
                '&.Mui-selected': {
                    borderColor: alpha(theme.palette[color].main, 0.48)
                }
            }
        });
    return {
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    variants: [
                        {
                            props: {
                                color: 'standard'
                            },
                            style: {
                                '&.Mui-selected': {
                                    backgroundColor: theme.palette.action.selected
                                }
                            }
                        },
                        style('primary'),
                        style('secondary'),
                        style('info'),
                        style('success'),
                        style('warning'),
                        style('error')
                    ]
                }
            }
        },
        MuiToggleButtonGroup: {
            styleOverrides: {
                root: {
                    borderRadius: theme.radius(1),
                    backgroundColor: theme.palette.background.paper,
                    border: `solid 1px ${theme.palette.grey[500_12]}`,
                    '& .MuiToggleButtonGroup-grouped:not(:first-of-type), & .MuiToggleButtonGroup-grouped:not(:last-of-type)': {
                        margin: 4,
                        borderColor: 'transparent',
                        borderRadius: theme.radius(1)
                    }
                }
            }
        }
    };
}
